<template>
  <section>
    <b-table :items="enrollmentItems" :fields="FIELDS" table-class="table-minimal" show-empty>
      <template #cell(value)="data">
        {{ getEnrollmentValue(data.item) }}
      </template>
    </b-table>
  </section>
</template>

<script setup>
import moment from 'moment';
import { computed } from 'vue';
import { EMPLOYEE_STATE } from '@/utils/Employee';
import { toFormattedDate } from '@/utils/date';

const HISTORY_KEYS = {
  STATUS_CHANGED: 'STATUS_CHANGED',
};

const HISTORY_LABELS = {
  [HISTORY_KEYS.STATUS_CHANGED]: 'New Status',
};

const HISTORY_VALUES = {
  [HISTORY_KEYS.STATUS_CHANGED]: item => item.properties.state,
};

const FIELDS = [
  {
    key: 'logged_at',
    label: 'Date/Time',
    sortable: true,
    formatter: value => toFormattedDate(value, 'YYYY-MM-DD HH:mm'),
  },
  {
    key: 'activity',
    label: 'Action',
    formatter: value => HISTORY_LABELS[value] || value,
  },
  {
    key: 'value',
    label: '',
  },
];

const props = defineProps({
  history: {
    type: Object,
    required: true,
  },
});

const enrollmentItems = computed(() => {
  const items = props.history.enrollment
    .filter(item => item.state !== EMPLOYEE_STATE.ENROLLING)
    .map(item => ({
      activity: HISTORY_KEYS.STATUS_CHANGED,
      logged_at: item.created_at,
      properties: { state: item.state },
    }));

  return items.sort((a, b) => moment(b.logged_at).diff(a.logged_at));
});

const getEnrollmentValue = item => {
  const valueFn = HISTORY_VALUES[item.activity];
  return typeof valueFn === 'function' ? valueFn(item) : '';
};
</script>
